import {API, Auth} from "aws-amplify";
import {User} from "../../entity/model/user";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {RequestBody} from "../../entity/core/request-body";

export default class UserAgent {

    getCurrentUser = async (): Promise<User> => {
        const awsUser = await Auth.currentAuthenticatedUser();
        return await API.get(awsApiName, `/users/${awsUser.username}`, {});
    }

    getUserById = async (userId: string): Promise<User> => {
        return await API.get(awsApiName, `/users/${userId}`, {});
    }

    getAllUsers = async (organizationID: string): Promise<User[]> => {
        return API.get(awsApiName, `/organizations/${organizationID}/users`, {})
    }

    createUser = async (organizationID: string, requestBody: RequestBody): Promise<User> => {
        return API.post(awsApiName, `/organizations/${organizationID}/users`, requestBody);
    }

    updateUser = async (organizationID: string, userId: string, requestBody: RequestBody): Promise<User> => {
        return API.patch(awsApiName, `/organizations/${organizationID}/users/${userId}`, requestBody);
    }

    deleteUser = async (organizationID: string, userId: string): Promise<void> => {
        return API.del(awsApiName, `/organizations/${organizationID}/users/${userId}`, {});
    }
}
